import { render, staticRenderFns } from "./newGroup.vue?vue&type=template&id=4a71a416"
import script from "./newGroup.vue?vue&type=script&lang=js"
export * from "./newGroup.vue?vue&type=script&lang=js"
import style0 from "./newGroup.vue?vue&type=style&index=0&id=4a71a416&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports